var accordionStyles = {
    root: function () { return ({
        verticalAlign: 'middle',
        display: 'flex',
        flexDirection: 'column',
    }); },
};
export default accordionStyles;
